import React from "react";
import "./Skills.css";
import SkillSection from "./SkillSection";
import { Fade } from "react-reveal";

export default function Skills(props) {
  const theme = props.theme;
  return (
    <div className="main" id="skills">
      <div className="skills-header-div">
        <Fade bottom duration={2000} distance="20px">
          <h1 className="skills-header" style={{ color: theme.text }}>
            Say hello to your core values!
          </h1>
          <h4 className="skills-header " style={{ fontSize: "20px" }}>
            Based on your responses, the 4 core values that match closest to
            your beliefs and attitudes are listed below.
          </h4>
        </Fade>
      </div>
      <SkillSection theme={theme} {...props} />
    </div>
  );
}
